import {Campaign} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/campaign.types';
import {GetDiscountsResponse_Discount} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/campaigns/v1/service.types';

export const isAppInstallIncentiveCampaign = (campaign: Campaign): boolean => {
  switch (campaign.type?.$case) {
    // Crazy bet / App Flash sale are categorised as `reduction` with `isAppOnlyCampaign`
    case 'reduction':
      return campaign.type.reduction.isAppOnlyCampaign;
    default:
      return false;
  }
};

export const filterSimpleAndAppInstallIncentiveCampaigns = (
  discount: GetDiscountsResponse_Discount | undefined,
) => {
  if (discount) {
    return !isAppInstallIncentiveCampaign(discount.campaign);
  } else {
    return true;
  }
};
